(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chewsy-ambassador"]) return;
  try {
    
  if (!customElements.get('chewsy-ambassador-dogs')) {
    customElements.define('chewsy-ambassador-dogs', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const form = this.closest('form');
        const rows = this.querySelector('[data-ambassador-dog-rows]');
        const add = this.querySelector('[data-dog-add]');
        const instagram = form.querySelector('[data-ambassador-instagram]');
        const customerAnswers = Array.from(form.querySelectorAll('[data-ambassador-customer-answer]'));
        const visible = () => Array.from(rows.querySelectorAll('[data-ambassador-dog]')).filter(row => !row.hidden);
        const renumber = () => {
          const dogs = visible();
          dogs.forEach((row, index) => {
            row.querySelector('[data-dog-legend]').textContent = this.dataset.dogLabel.replace('__number__', String(index + 1));
            const remove = row.querySelector('[data-dog-remove]');
            remove.hidden = dogs.length === 1;
            remove.setAttribute('aria-label', this.dataset.removeLabel.replace('__number__', String(index + 1)));
            row.querySelectorAll('[data-dog-field]').forEach(field => { field.name = 'contact[Dog ' + (index + 1) + ' ' + field.dataset.dogField + ']'; });
          });
          add.disabled = dogs.length >= 5;
        };
        add.hidden = false;
        add.addEventListener('click', () => {
          if (visible().length >= 5) return;
          const row = Array.from(rows.querySelectorAll('[data-ambassador-dog]')).find(item => item.hidden);
          if (!row) return;
          rows.append(row); row.hidden = false;
          row.querySelectorAll('[data-dog-field]').forEach(field => { field.disabled = false; });
          renumber(); row.querySelector('[data-dog-field="name"]').focus();
        });
        rows.addEventListener('click', event => {
          const remove = event.target.closest('[data-dog-remove]');
          if (!remove || !rows.contains(remove) || visible().length <= 1) return;
          const row = remove.closest('[data-ambassador-dog]'); row.hidden = true;
          row.querySelectorAll('[data-dog-field]').forEach(field => { field.value = ''; field.disabled = true; field.setCustomValidity(''); });
          renumber(); add.focus();
        });
        const normalizeHandle = () => { instagram.value = '@' + instagram.value.trim().replace(/^@/, '').toLowerCase(); };
        instagram.addEventListener('blur', () => { if (instagram.value.trim()) normalizeHandle(); });
        rows.addEventListener('input', event => { if (event.target.matches('[data-dog-field]')) event.target.setCustomValidity(''); });
        form.addEventListener('input', event => { if (event.target.matches('[data-ambassador-customer-answer]')) event.target.setCustomValidity(''); });
        form.addEventListener('submit', event => {
          if (instagram.value.trim()) normalizeHandle();
          customerAnswers.forEach(field => {
            field.value = field.value.trim();
            field.setCustomValidity(!field.value ? this.dataset.answerRequired : '');
          });
          visible().forEach(row => row.querySelectorAll('[data-dog-field]').forEach(field => {
            field.value = field.value.trim();
            field.setCustomValidity(field.required && !field.value ? this.dataset.requiredLabel : '');
          }));
          if (!form.reportValidity()) event.preventDefault();
        });
        renumber();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
